import { HTMLAttributes } from 'react';
import { foundationRadiusTokens, foundationSemantic } from '../../foundation';
import { cx } from './utils';

interface MenuProps extends HTMLAttributes<HTMLDivElement> {
  labelledBy?: string;
}

export default function Menu({ className, labelledBy, ...props }: MenuProps) {
  return (
    <div
      role="menu"
      aria-labelledby={labelledBy}
      className={cx(
        `min-w-[12rem] border py-1 ${foundationRadiusTokens.md}`,
        foundationSemantic.menu.container,
        className
      )}
      {...props}
    />
  );
}

export type { MenuProps };
